var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-permissions"},[_c('div',{staticClass:"tiny__content"},[_c('p',{staticClass:"tiny__content__title"},[_vm._v("АКТИВНОСТ")]),_c('hr',{staticClass:"line"})])])
}]

export { render, staticRenderFns }